<template>
  <div class="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
    <div
      v-for="({ chemical_formula, total_emissions, total_emissions_mtco2 }, index) in selectedPollutants"
      :key="index"
      class="w-full px-6 py-6 bg-white border rounded-md shadow-sm cursor-pointer hover:drop-shadow-sm border-slate-200"
      @click="$emit('pollutantSelected', index)"
    >
      <div class="flex justify-between">
        <div>
          <span class="font-sans text-base font-semibold text-gray-400">{{ chemical_formula }}</span>
        </div>
        <div>
          <div class="inline-block w-5 overflow-hidden">
            <div
              class="w-3 h-3 origin-bottom-left transform rotate-45"
              :class="{ 'bg-green-600': total_emissions, 'bg-green-600/50': !total_emissions }"
            />
          </div>
        </div>
      </div>
      <div class="mt-2 text-right">
        <p class="font-sans font-normal text-gray-400">
          {{ formatThousands(total_emissions) }} Mt
        </p>
        <h3 class="font-sans text-base font-medium leading-tight text-gray-900 md:text-lg lg:text-2xl">
          = {{ formatThousands(total_emissions_mtco2) }}
        </h3>
        <p class="font-sans font-medium text-gray-400">
          tCO2e
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelectedPollutantCards',

  props: {
    pollutants: {
      type: Array,
      required: true,
    },
  },

  emits: ['pollutantSelected'],

  data() {
    return {
      selectedPollutants: this.pollutants,
    }
  },

  watch: {
    pollutants(newPollutants) {
      this.selectedPollutants = newPollutants
    },
  },

  methods: {
    formatThousands(metric) {
      return thousands(metric, 2, true)
    },
  },
}
</script>
